import axios from 'axios';
import { DCPConference } from '@/models/DCPConference';

/**
 * API calls for DCP-Operator-Service
 * @module service/DCPOperatorService
 */
export default {
	// API Calls
	getDCPConferences(): Promise<DCPConference[]> {
		return axios.get('/dcp/operator').then((res) => res.data);
	},
  stopDCPConference(id: string): Promise<void> {
    return axios.post('/dcp/operator/stop', { id }).then((res) => res.data);
  }
};
